import { DeckCardDefinition } from './decks';

export const STANDARD_DECK_CARDS: DeckCardDefinition[] = [
  {
    "name": "The Fool",
    "meaning": "Folly, mania, extravagance, intoxication, delirium, frenzy, bewrayment.",
    "reversedMeaning": "Negligence, absence, distribution, carelessness, apathy, nullity, vanity.",
    "arcana": "Major",
    "number": 0,
    "filename": "02000.jpg"
  },
  {
    "name": "The Magician",
    "meaning": "Skill, diplomacy, address, subtlety; sickness, pain, loss, disaster, self-confidence, will, the Querent himself.",
    "reversedMeaning": "Physician, Magus, mental disease, disgrace, disquiet.",
    "arcana": "Major",
    "number": 1,
    "filename": "02001.jpg"
  },
  {
    "name": "The High Priestess",
    "meaning": "Secrets, mystery, the future as yet unrevealed; the woman who interests the Querent, silence, tenacity, wisdom, science.",
    "reversedMeaning": "Passion, moral or physical ardour, conceit, surface knowledge.",
    "arcana": "Major",
    "number": 2,
    "filename": "02002.jpg"
  },
  {
    "name": "The Empress",
    "meaning": "Fruitfulness, action, initiative, length of days; the unknown, clandestine; also difficulty, doubt, ignorance.",
    "reversedMeaning": "Light, truth, unraveling of involved matters, public rejoicings.",
    "arcana": "Major",
    "number": 3,
    "filename": "02003.jpg"
  },
  {
    "name": "The Emperor",
    "meaning": "Stability, power, protection, realization; a great person; aid, reason, conviction.",
    "reversedMeaning": "Benevolence, compassion, credit; also confusion to enemies, obstruction, immaturity.",
    "arcana": "Major",
    "number": 4,
    "filename": "02004.jpg"
  },
  {
    "name": "The Hierophant",
    "meaning": "Marriage, alliance, captivity, servitude; by another account, mercy and goodness; inspiration; the man to whom the Querent has recourse.",
    "reversedMeaning": "Society, good understanding, concord, overkindness, weakness.",
    "arcana": "Major",
    "number": 5,
    "filename": "02005.jpg"
  },
  {
    "name": "The Lovers",
    "meaning": "Attraction, love, beauty, trials overcome.",
    "reversedMeaning": "Failure, foolish designs.",
    "arcana": "Major",
    "number": 6,
    "filename": "02006.jpg"
  },
  {
    "name": "The Chariot",
    "meaning": "Succour, providence, also war, triumph, presumption, vengeance, trouble.",
    "reversedMeaning": "Riot, quarrel, dispute, litigation, defeat.",
    "arcana": "Major",
    "number": 7,
    "filename": "02007.jpg"
  },
  {
    "name": "Strength",
    "meaning": "Power, energy, action, courage, magnanimity; also complete success and honours.",
    "reversedMeaning": "Abuse of power, despotism, weakness, discord.",
    "arcana": "Major",
    "number": 8,
    "filename": "02008.jpg"
  },
  {
    "name": "The Hermit",
    "meaning": "Prudence, also and especially treason, corruption, roguery; retirement, solitude.",
    "reversedMeaning": "Concealment, disguise, policy, fear, unreasoned caution.",
    "arcana": "Major",
    "number": 9,
    "filename": "02009.jpg"
  },
  {
    "name": "Wheel of Fortune",
    "meaning": "Destiny, fortune, success, elevation, luck, felicity.",
    "reversedMeaning": "Increase, abundance, superfluity.",
    "arcana": "Major",
    "number": 10,
    "filename": "02010.jpg"
  },
  {
    "name": "Justice",
    "meaning": "Equity, rightness, probity, executive; triumph of the deserving side in law.",
    "reversedMeaning": "Law in all its departments, bigotry, bias, excessive severity.",
    "arcana": "Major",
    "number": 11,
    "filename": "02011.jpg"
  },
  {
    "name": "The Hanged Man",
    "meaning": "Wisdom, circumspection, discernment, trials, sacrifice, intuition, divination, prophecy.",
    "reversedMeaning": "Selfishness, the crowd, body politic.",
    "arcana": "Major",
    "number": 12,
    "filename": "02012.jpg"
  },
  {
    "name": "Death",
    "meaning": "End, mortality, destruction, corruption; also for a man, the loss of a benefactor; for a woman, many contrarieties.",
    "reversedMeaning": "Inertia, sleep, lethargy, petrifaction, somnambulism; hope destroyed.",
    "arcana": "Major",
    "number": 13,
    "filename": "02013.jpg"
  },
  {
    "name": "Temperance",
    "meaning": "Economy, moderation, frugality, management, accommodation.",
    "reversedMeaning": "Things connected with churches, religions, sects, the priesthood.",
    "arcana": "Major",
    "number": 14,
    "filename": "02014.jpg"
  },
  {
    "name": "The Devil",
    "meaning": "Ravage, violence, vehemence, extraordinary efforts, force, fatality; that which is predestined but not for this reason evil.",
    "reversedMeaning": "Evil fatality, weakness, pettiness, blindness.",
    "arcana": "Major",
    "number": 15,
    "filename": "02015.jpg"
  },
  {
    "name": "The Tower",
    "meaning": "Misery, distress, ruin, indigence, adversity, calamity, disgrace, deception, ruin.",
    "reversedMeaning": "Oppression, imprisonment, tyranny.",
    "arcana": "Major",
    "number": 16,
    "filename": "02016.jpg"
  },
  {
    "name": "The Star",
    "meaning": "Loss, theft, privation, abandonment, another reading says hope and bright prospects in the future.",
    "reversedMeaning": "Arrogance, haughtiness, impotence.",
    "arcana": "Major",
    "number": 17,
    "filename": "02017.jpg"
  },
  {
    "name": "The Moon",
    "meaning": "Hidden enemies, danger, calumny, darkness, terror, deception, error.",
    "reversedMeaning": "Instability, inconstancy, silence, lesser degrees of deception and error.",
    "arcana": "Major",
    "number": 18,
    "filename": "02018.jpg"
  },
  {
    "name": "The Sun",
    "meaning": "Material happiness, fortunate marriage, contentment.",
    "reversedMeaning": "The same in a lesser sense.",
    "arcana": "Major",
    "number": 19,
    "filename": "02019.jpg"
  },
  {
    "name": "Judgement",
    "meaning": "Change of position, renewal, outcome; another account specifies total loss through lawsuit.",
    "reversedMeaning": "Weakness, pusillanimity, simplicity, deliberation, decision, sentence.",
    "arcana": "Major",
    "number": 20,
    "filename": "02020.jpg"
  },
  {
    "name": "The World",
    "meaning": "Assured success, recompense, voyage, route, emigration, flight, change of place.",
    "reversedMeaning": "Inertia, fixity, stagnation, permanence.",
    "arcana": "Major",
    "number": 21,
    "filename": "02021.jpg"
  },
  {
    "name": "Ace of Cups",
    "meaning": "House of the true heart, joy, content, abundance, fertility, nourishment.",
    "reversedMeaning": "House of the false heart, instability, revolution, unrequited love.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 1,
    "filename": "02022.jpg"
  },
  {
    "name": "Two of Cups",
    "meaning": "Love, passion, friendship, affinity, union, concord, sympathy, the interrelation of the sexes.",
    "reversedMeaning": "False love, folly, misunderstanding.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 2,
    "filename": "02023.jpg"
  },
  {
    "name": "Three of Cups",
    "meaning": "The conclusion of any matter in plenty, perfection and merriment; happy issue, victory, fulfilment, solace, healing.",
    "reversedMeaning": "Expedition, dispatch, achievement, end, conclusion, solace, healing.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 3,
    "filename": "02024.jpg"
  },
  {
    "name": "Four of Cups",
    "meaning": "Weariness, disgust, aversion, imaginary vexations, as if the wine of life had been drunk and only the lees remained.",
    "reversedMeaning": "Novelty, presage, new instruction, new relations.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 4,
    "filename": "02025.jpg"
  },
  {
    "name": "Five of Cups",
    "meaning": "Loss, but something remains; inheritance, transmission, patrimony, marriage, but not without bitterness or frustration.",
    "reversedMeaning": "News, alliances, affinity, consanguinity, ancestry, return, false projects.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 5,
    "filename": "02026.jpg"
  },
  {
    "name": "Six of Cups",
    "meaning": "A card of the past and of memories, looking back, as for example on childhood, happiness, enjoyment, but coming rather from the past.",
    "reversedMeaning": "The future, renewal, that which will come to pass presently.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 6,
    "filename": "02027.jpg"
  },
  {
    "name": "Seven of Cups",
    "meaning": "Fairy favours, images of reflection, sentiment, imagination, things seen in the glass of contemplation; some attainment in these degrees, but nothing permanent or substantial.",
    "reversedMeaning": "Desire, will, determination, project.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 7,
    "filename": "02028.jpg"
  },
  {
    "name": "Eight of Cups",
    "meaning": "The card speaks for itself on the surface, but other readings are: modesty, mildness, abandoned success.",
    "reversedMeaning": "Great joy, happiness, feasting.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 8,
    "filename": "02029.jpg"
  },
  {
    "name": "Nine of Cups",
    "meaning": "Concord, contentment, physical well-being; victory, success, advantage, satisfaction for the Querent or person for whom the consultation is made.",
    "reversedMeaning": "Truth, loyalty, liberty; but the readings are sometimes mistakes through superficiality.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 9,
    "filename": "02030.jpg"
  },
  {
    "name": "Ten of Cups",
    "meaning": "Contentment, repose of the entire heart; the perfection of that state; also the town, village or country inhabited by the Querent.",
    "reversedMeaning": "Repose of the false heart, indignation, violence.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 10,
    "filename": "02031.jpg"
  },
  {
    "name": "Page of Cups",
    "meaning": "Fair young man, one impelled to render service and with whom the Querent will be connected; a studious youth, news, message, application, reflection, meditation.",
    "reversedMeaning": "Taste, inclination, attachment, seduction, deception, artifice.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 11,
    "filename": "02032.jpg"
  },
  {
    "name": "Knight of Cups",
    "meaning": "Arrival, approach—sometimes that of a messenger; advances, proposition, demeanour, invitation, incitement.",
    "reversedMeaning": "Trickery, artifice, subtlety, swindling, duplicity, fraud.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 12,
    "filename": "02033.jpg"
  },
  {
    "name": "Queen of Cups",
    "meaning": "Good, fair woman; honest, devoted woman; perverse woman; distinguished woman; one who presents a gift.",
    "reversedMeaning": "The accounts vary; good woman, otherwise distinguished woman but one not to be trusted; perverse woman, dishonest.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 13,
    "filename": "02034.jpg"
  },
  {
    "name": "King of Cups",
    "meaning": "Fair man, man of business, law, or divinity; responsible, disposed to oblige the Querent; also equity, art, and science, including those who profess science, law and art.",
    "reversedMeaning": "Dishonest, double-dealing man; roguery, exaction, injustice, vice, scandal, loss.",
    "arcana": "Minor",
    "suit": "Cups",
    "number": 14,
    "filename": "02035.jpg"
  },
  {
    "name": "Ace of Pentacles",
    "meaning": "Perfect contentment, felicity, ecstasy; also speedy intelligence; gold.",
    "reversedMeaning": "The evil side of wealth, bad intelligence; also great riches.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 1,
    "filename": "02036.jpg"
  },
  {
    "name": "Two of Pentacles",
    "meaning": "On the one hand it is represented as gaiety, recreation, and its connections; on the other, news and messages in writing; as obstacles, agitation, trouble, embroilment.",
    "reversedMeaning": "Enforced gaiety, simulated enjoyment, literal sense, handwriting, composition, letters of exchange.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 2,
    "filename": "02037.jpg"
  },
  {
    "name": "Three of Pentacles",
    "meaning": "Trade, skilled labour; usually, however, regarded as a card of nobility, aristocracy, renown, glory.",
    "reversedMeaning": "Mediocrity in work and otherwise, puerility, pettiness, weakness.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 3,
    "filename": "02038.jpg"
  },
  {
    "name": "Four of Pentacles",
    "meaning": "The surety of possessions, cleaving to that which one has, gift, legacy, inheritance.",
    "reversedMeaning": "Suspense, delay, opposition.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 4,
    "filename": "02039.jpg"
  },
  {
    "name": "Five of Pentacles",
    "meaning": "Material trouble above all, whether in the form illustrated—that is, destitution—or otherwise.",
    "reversedMeaning": "Disorder, chaos, ruin, discord, profligacy.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 5,
    "filename": "02040.jpg"
  },
  {
    "name": "Six of Pentacles",
    "meaning": "Presents, gifts, gratification; another account says attention, vigilance, now is the accepted time, present prosperity, etc.",
    "reversedMeaning": "Desire, cupidity, envy, jealousy, illusion.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 6,
    "filename": "02041.jpg"
  },
  {
    "name": "Seven of Pentacles",
    "meaning": "These are exceedingly contradictory; in the main, it is a card of money, business, barter; altercation, quarrels—innocent and unimportant.",
    "reversedMeaning": "Cause for anxiety regarding money which it may be proposed to lend.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 7,
    "filename": "02042.jpg"
  },
  {
    "name": "Eight of Pentacles",
    "meaning": "Work, employment, commission, craftsmanship, skill in craft and business, perhaps in the preparatory stage.",
    "reversedMeaning": "Voided ambition, vanity, cupidity, exaction, usury.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 8,
    "filename": "02043.jpg"
  },
  {
    "name": "Nine of Pentacles",
    "meaning": "Prudence, safety, success, accomplishment, certitude, discernment.",
    "reversedMeaning": "Roguery, deception, voided project, bad faith.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 9,
    "filename": "02044.jpg"
  },
  {
    "name": "Ten of Pentacles",
    "meaning": "Gain, riches; family matters, archives, extraction, the abode of a family.",
    "reversedMeaning": "Chance, fatality, loss, robbery, games of hazard; sometimes gift, dowry, pension.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 10,
    "filename": "02045.jpg"
  },
  {
    "name": "Page of Pentacles",
    "meaning": "Application, study, scholarship, reflection; another reading says news, messages and the bringer thereof; also rule and management.",
    "reversedMeaning": "Prodigality, dissipation, liberality, luxury, unfavourable news.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 11,
    "filename": "02046.jpg"
  },
  {
    "name": "Knight of Pentacles",
    "meaning": "Utility, serviceableness, interest, responsibility, rectitude—all on the normal and external plane.",
    "reversedMeaning": "Inertia, idleness, repose of that kind, stagnation; discouragement, carelessness.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 12,
    "filename": "02047.jpg"
  },
  {
    "name": "Queen of Pentacles",
    "meaning": "Opulence, generosity, magnificence, security, liberty.",
    "reversedMeaning": "Evil, suspicion, suspense, fear, mistrust.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 13,
    "filename": "02048.jpg"
  },
  {
    "name": "King of Pentacles",
    "meaning": "Valour, intelligence, business, mathematical gifts, successful in these paths.",
    "reversedMeaning": "Vice, weakness, ugliness, perversity, corruption, peril.",
    "arcana": "Minor",
    "suit": "Pentacles",
    "number": 14,
    "filename": "02049.jpg"
  },
  {
    "name": "Ace of Swords",
    "meaning": "Triumph, the excessive degree in everything, conquest, triumph of force; a card of great force, in love as well as in hatred.",
    "reversedMeaning": "The same, but the results are disastrous; another account says conception, childbirth, augmentation, multiplicity.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 1,
    "filename": "02050.jpg"
  },
  {
    "name": "Two of Swords",
    "meaning": "Conformity and the equipoise which it suggests, courage, friendship, concord in a state of arms; affection, intimacy.",
    "reversedMeaning": "Imposture, falsehood, duplicity, disloyalty.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 2,
    "filename": "02051.jpg"
  },
  {
    "name": "Three of Swords",
    "meaning": "Removal, absence, delay, division, rupture, dispersion, and all that the design signifies naturally.",
    "reversedMeaning": "Mental alienation, error, loss, distraction, disorder, confusion.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 3,
    "filename": "02052.jpg"
  },
  {
    "name": "Four of Swords",
    "meaning": "Vigilance, retreat, solitude, exile, tomb and coffin.",
    "reversedMeaning": "Wise administration, circumspection, economy, avarice, precaution, testament.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 4,
    "filename": "02053.jpg"
  },
  {
    "name": "Five of Swords",
    "meaning": "Degradation, destruction, revocation, infamy, dishonour, loss, with the variants and analogues of these.",
    "reversedMeaning": "The same; burial and obsequies.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 5,
    "filename": "02054.jpg"
  },
  {
    "name": "Six of Swords",
    "meaning": "Journey by water, route, way, envoy, commissionary, expedient.",
    "reversedMeaning": "Declaration, confession, publicity; one account says that it is a proposal of love.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 6,
    "filename": "02055.jpg"
  },
  {
    "name": "Seven of Swords",
    "meaning": "Design, attempt, wish, hope, confidence; also quarrelling, a plan that may fail, annoyance.",
    "reversedMeaning": "Good advice, counsel, instruction, slander, babbling.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 7,
    "filename": "02056.jpg"
  },
  {
    "name": "Eight of Swords",
    "meaning": "Bad news, violent chagrin, crisis, censure, power in trammels, conflict, calumny; also sickness.",
    "reversedMeaning": "Disquiet, difficulty, opposition, accident, treachery; what is unforeseen; fatality.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 8,
    "filename": "02057.jpg"
  },
  {
    "name": "Nine of Swords",
    "meaning": "Death, failure, miscarriage, delay, deception, disappointment, despair.",
    "reversedMeaning": "Imprisonment, suspicion, doubt, reasonable fear, shame.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 9,
    "filename": "02058.jpg"
  },
  {
    "name": "Ten of Swords",
    "meaning": "Whatsoever is intimated by the design; also pain, affliction, tears, sadness, desolation.",
    "reversedMeaning": "Advantage, profit, success, favour; but none of these are permanent; also power and authority.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 10,
    "filename": "02059.jpg"
  },
  {
    "name": "Page of Swords",
    "meaning": "Authority, overseeing, secret service, vigilance, spying, examination, and the qualities thereto belonging.",
    "reversedMeaning": "More evil side of these qualities; what is unforeseen, unprepared state, sickness is also intimated.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 11,
    "filename": "02060.jpg"
  },
  {
    "name": "Knight of Swords",
    "meaning": "Skill, bravery, capacity, defence, address, wrath, war, destruction, opposition, resistance, ruin.",
    "reversedMeaning": "Imprudence, incapacity, extravagance.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 12,
    "filename": "02061.jpg"
  },
  {
    "name": "Queen of Swords",
    "meaning": "Widowhood, female sadness and embarrassment, absence, sterility, mourning, privation, separation.",
    "reversedMeaning": "Malice, bigotry, artifice, prudery, bale, deceit.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 13,
    "filename": "02062.jpg"
  },
  {
    "name": "King of Swords",
    "meaning": "Whatsoever arises out of the idea of judgement and all its connexions—power, command, authority, militant intelligence, law, offices of the crown, and so forth.",
    "reversedMeaning": "Cruelty, perversity, barbarity, perfidy, evil intention.",
    "arcana": "Minor",
    "suit": "Swords",
    "number": 14,
    "filename": "02063.jpg"
  },
  {
    "name": "Ace of Wands",
    "meaning": "Creation, invention, enterprise, the powers which result in these; principle, beginning, source; birth, family, origin, and the beginning of enterprises.",
    "reversedMeaning": "Fall, decadence, ruin, perdition, to perish, also a certain clouded joy.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 1,
    "filename": "02064.jpg"
  },
  {
    "name": "Two of Wands",
    "meaning": "Between the alternative readings there is no marriage possible; on the one hand, riches, fortune, magnificence; on the other, physical suffering, disease, chagrin, sadness, mortification.",
    "reversedMeaning": "Surprise, wonder, enchantment, emotion, trouble, fear.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 2,
    "filename": "02065.jpg"
  },
  {
    "name": "Three of Wands",
    "meaning": "He symbolizes established strength, enterprise, effort, trade, commerce, discovery; those are his ships bearing his merchandise, which are sailing over the sea.",
    "reversedMeaning": "The end of troubles, suspension or cessation of adversity, end of disappointment.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 3,
    "filename": "02066.jpg"
  },
  {
    "name": "Four of Wands",
    "meaning": "They are for once almost on the surface—country life, repose, concord, harmony, prosperity, peace, and the perfected work of these.",
    "reversedMeaning": "The meaning remains unaltered; it is prosperity, increase, felicity, beauty, embellishment.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 4,
    "filename": "02067.jpg"
  },
  {
    "name": "Five of Wands",
    "meaning": "Imitation, for example, sham fight, as in a sport or display, yet struggle for riches and fortune; some authors say it is a card of gold, gain, opulence.",
    "reversedMeaning": "Litigation, disputes, trickery, contradiction.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 5,
    "filename": "02068.jpg"
  },
  {
    "name": "Six of Wands",
    "meaning": "The card has been so designed that it can cover several significations; on the surface, it is a victor triumphing; also great news, expectation, crowned with its own desire; the crown of hope.",
    "reversedMeaning": "Apprehension, fear, as of a victorious enemy at the gate, treachery, disloyalty.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 6,
    "filename": "02069.jpg"
  },
  {
    "name": "Seven of Wands",
    "meaning": "It is a card of valour, for on the surface, six are attacking one, who has, however, the vantage position; on the intellectual plane, it signifies discussion, wordy strife, in business—negotiations, war of trade, competition; it is further a card of success, for the combatant is on the top and his enemies may be unable to reach him.",
    "reversedMeaning": "Perplexity, embarrassments, anxiety, also caution.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 7,
    "filename": "02070.jpg"
  },
  {
    "name": "Eight of Wands",
    "meaning": "Activity in undertakings, the path of such activity, swiftness, as that of an express messenger; great haste, great hope, speed towards an end which promises assured felicity; generally, that which is on the move; also the arrows of love.",
    "reversedMeaning": "Arrows of jealousy, internal dispute, stingings of conscience, quarrels.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 8,
    "filename": "02071.jpg"
  },
  {
    "name": "Nine of Wands",
    "meaning": "The card signifies strength in opposition; if attacked, the person will meet an onslaught boldly; and his build shows that he may prove a formidable antagonist; with this main significance there are all its possible adjuncts—delay, suspension, adjournment.",
    "reversedMeaning": "Obstacles, adversity, calamity.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 9,
    "filename": "02072.jpg"
  },
  {
    "name": "Ten of Wands",
    "meaning": "A card of many significances, and some of the readings cannot be harmonized; oppression simply; but also fortune, gain, any kind of success, and then the oppression of these things; it is also a card of false-seeming, disguise, perfidy.",
    "reversedMeaning": "Contrarieties, difficulties, intrigues, and their analogies.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 10,
    "filename": "02073.jpg"
  },
  {
    "name": "Page of Wands",
    "meaning": "Dark young man, faithful, a lover, an envoy, a postman; beside a man, he will bear favourable testimony concerning him; a dangerous rival, if followed by the Page of Cups; he may signify that which is unexpected; a messenger of good tidings.",
    "reversedMeaning": "Anecdotes, announcements, evil news; also indecision and the instability which accompanies it.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 11,
    "filename": "02074.jpg"
  },
  {
    "name": "Knight of Wands",
    "meaning": "Departure, absence, flight, emigration; a dark young man, friendly; change of residence.",
    "reversedMeaning": "Rupture, division, interruption, discord.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 12,
    "filename": "02075.jpg"
  },
  {
    "name": "Queen of Wands",
    "meaning": "A dark woman, country woman, friendly, chaste, loving, honourable; if the card beside her signifies a man, she is well disposed towards him; if a woman, she is interested in the Querent; also love of money.",
    "reversedMeaning": "Good, economical woman, obliged to interest herself in business; serviceable, also signifies opposition, jealousy, deceit, infidelity.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 13,
    "filename": "02076.jpg"
  },
  {
    "name": "King of Wands",
    "meaning": "Dark man, friendly, countryman, generally married, honest and conscientious; the card also signifies honour, and possibly money obtained through honourable means.",
    "reversedMeaning": "Good, but severe; austere, yet tolerant.",
    "arcana": "Minor",
    "suit": "Wands",
    "number": 14,
    "filename": "02077.jpg"
  }
];
